import {Getter, GetterTree} from 'vuex';
import {HomeState} from "@/module/home/store/home-state";

export const Getters: GetterTree<HomeState, any> = {};
